import script from "./useRestApi.vue?vue&type=script&lang=js"
export * from "./useRestApi.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__